import React from "react";
import { siteData } from "../mock";
import { Users, Heart } from "lucide-react";

const icons = [Users, Heart];

const Experience = () => {
  const { experience } = siteData;
  return (
    <section
      id="experience"
      className="py-24 lg:py-32 bg-[#f6f9fc]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl ring-1 ring-[#e2eaf2] bg-white">
              <img
                src={experience.image}
                alt="Mobile app preview"
                className="w-full h-[440px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#3d4e62]/25 via-transparent to-transparent" />
            </div>
            <div className="absolute -inset-4 -z-10 rounded-3xl bg-gradient-to-br from-[#eaf4fb] to-[#dfeefa] blur-2xl opacity-70" />
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-[#4a90c2] font-semibold uppercase tracking-[0.18em] text-sm ht-body">
              {experience.eyebrow}
            </p>
            <h2 className="mt-4 ht-display text-3xl sm:text-4xl lg:text-5xl text-[#2c3e50] leading-[1.1]">
              {experience.title}
            </h2>
            <p className="mt-6 ht-body text-[#5a6b7d] text-base sm:text-lg leading-relaxed">
              {experience.bodyOne}
            </p>
            <p className="mt-4 ht-body text-[#5a6b7d] text-base sm:text-lg leading-relaxed">
              {experience.bodyTwo}
            </p>

            <div className="mt-8 space-y-5">
              {experience.features.map((f, i) => {
                const Icon = icons[i % icons.length];
                return (
                  <div
                    key={f.title}
                    className="ht-card flex items-start gap-4 rounded-xl bg-white border border-[#e6eef5] p-4 sm:p-5"
                  >
                    <span className="mt-1 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#eaf4fb] text-[#3d6486]">
                      <Icon className="h-5 w-5" />
                    </span>
                    <div>
                      <p className="font-semibold text-[#2c3e50] ht-body">
                        {f.title}
                      </p>
                      <p className="mt-1 text-[#5a6b7d] ht-body text-sm sm:text-base">
                        {f.text}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
